import type {
  AddAdminRequest,
  AddAdminResponse,
  AdminActionRequest,
  AdminsResponse,
  ErrorsResponse,
  OwnerHealthResponse,
  SettingsResponse,
  SystemSettings,
} from '@crew/shared';
import type { User } from 'firebase/auth';
import { demoStore } from '@/demo/demoStore';
import { IS_DEMO } from '@/demo/demoMode';
import { apiRequest } from './api';

/** קריאות מסך המפתח. השרת מאשר בכל קריאה שהמשתמש הוא המפתח (OWNER_UID). */
export interface OwnerApi {
  admins(): Promise<AdminsResponse>;
  addAdmin(body: AddAdminRequest): Promise<AddAdminResponse>;
  adminAction(uid: string, body: AdminActionRequest): Promise<{ ok: true } | { passwordLink: string }>;
  settings(): Promise<SettingsResponse>;
  updateSettings(patch: Partial<SystemSettings>): Promise<SettingsResponse>;
  health(): Promise<OwnerHealthResponse>;
  errors(): Promise<ErrorsResponse>;
  clearErrors(): Promise<{ deleted: number }>;
  setQuiet(quietMode: boolean): Promise<{ ok: true; quietMode: boolean }>;
}

const enc = encodeURIComponent;

export function ownerApi(user: User): OwnerApi {
  if (IS_DEMO) {
    return {
      admins: () => demoStore.ownerAdmins(),
      addAdmin: (b) => demoStore.ownerAddAdmin(b),
      adminAction: (uid, b) => demoStore.ownerAdminAction(uid, b),
      settings: () => demoStore.ownerSettings(),
      updateSettings: (p) => demoStore.ownerUpdateSettings(p),
      health: () => demoStore.ownerHealth(),
      errors: () => demoStore.ownerErrors(),
      clearErrors: () => demoStore.ownerClearErrors(),
      setQuiet: (q) => demoStore.ownerSetQuiet(q),
    };
  }
  return {
    admins: () => apiRequest('/api/owner/admins', { user }),
    addAdmin: (body) => apiRequest('/api/owner/admins', { method: 'POST', body, user }),
    adminAction: (uid, body) => apiRequest(`/api/owner/admins/${enc(uid)}`, { method: 'POST', body, user }),
    settings: () => apiRequest('/api/owner/settings', { user }),
    updateSettings: (body) => apiRequest('/api/owner/settings', { method: 'PATCH', body, user }),
    health: () => apiRequest('/api/owner/health', { user }),
    errors: () => apiRequest('/api/owner/errors', { user }),
    clearErrors: () => apiRequest('/api/owner/errors', { method: 'DELETE', user }),
    setQuiet: (quietMode) => apiRequest('/api/owner/quiet', { method: 'POST', body: { quietMode }, user }),
  };
}
